import { AEntity, Entity, Object3DSetEvent, RenderTargetLoadedEvent, Scene } from "aframe";
import { Object3D } from "three";

export function waitForObject3D(el : Entity, type : string = "mesh") : Promise<Object3D>
{
	return new Promise<Object3D>( (yes, no) =>
	{
		if(!el) return no(el);
		if(type in el.object3DMap) return yes(el.object3DMap[type]);
		const listener = (e:Object3DSetEvent) =>
		{
			if(e.target !== el) return;
			if(e.detail.type != type) return;
			el.removeEventListener("object3dset", listener as any);
			yes(e.detail.object);
		};
		el.addEventListener("object3dset", listener);
	})
}


export async function waitForParentsLoaded(entity : Entity) : Promise<Entity>
{
	for(let el = entity; el instanceof AEntity; el = el.parentEl!)
	{
		if(!el.hasLoaded)
			await new Promise( (resolve, _) => el.addEventListener("loaded", resolve, {once:true}) );
	}
	return entity;
}

export function waitForLoaded(entity : Entity) : Promise<Entity>
{
	return new Promise<Entity>( (loaded, _) =>
	{
		if(entity.hasLoaded) return loaded(entity);
		entity.addEventListener("loaded", () => loaded(entity), {once:true});
	})
}
export function whenLoaded(entity : Entity, callback : (event?:Event) => void )
{
	if(entity.hasLoaded) return callback();
	entity.addEventListener("loaded", callback, {once:true});
}

export function waitForCanvasReady(scene : Scene) : Promise< HTMLCanvasElement >
{
	return new Promise<HTMLCanvasElement>( (ready,n) =>
	{
		if(scene.canvas) return ready(scene.canvas);
		const listener = (event : RenderTargetLoadedEvent) => ready(event.detail.target);
		scene.addEventListener("render-target-loaded", listener, {once:true});
	} );
}



export class Lazy<Type>
{
	execute : Function | null;
	that : any;
	args : any[];
	result? : Type;
	constructor( execute : Function, thisArg? : any, ...args : any[] ) { 
		this.execute = execute;
		this.that = thisArg;
		this.args = args;
	}
	get() : Type
	{
		if(this.execute)
		{
			this.result = this.execute.apply(this.that, this.args);
			this.execute = null;
		}	
		return this.result!;
	}
}



export function traverseEntity(el : Entity, callback : Function, obj : Object3D & { el? : Entity } = el.object3D, callbackThis : any = undefined, ...callbackArgs : any[] )
{
	if(obj.el && (obj.el !== el)) return;
	let result = callback.call(callbackThis, obj, ...callbackArgs);
	for(let ix=0, N=obj.children.length; (ix<N) && !result; ++ix)
		result = traverseEntity(el, callback, obj.children[ix], callbackThis, ...callbackArgs );
	return result;
}


export function pathOf(obj : Object3D, root : Object3D, sep : string = "/")
{
	let path = obj.name;
	for( let p = obj.parent; p && (p !== root); p = p.parent)
		path = p.name + sep + path;
	return path;
}


